import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { Card, Stack, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import compInfos from "./charge-from.json";
import { useLangContext } from "../../context/langContext";
import { object, string } from "yup";
import { useProtectedAxiosInstance } from "../../hooks/axiosInstance";
import errorResolver from "../../utils/error-resolver";
import { useNotificationContext } from "../../context/notificationContext";
import MuiTextField from "../../components/common/text-field/MuiTextField";
import { GatewaySchema } from "../../services/Schemas/Gateway";
import { GatewayListRequest } from "../../services/Endpoints/gateway/GatewayListEndpoint";
import { WalletChargeRequest } from "../../services/Endpoints/wallet/WalletChargeEndpoint";
import { useWorkspaceContext } from "../../context/workspaceContext";
import constants from "../../constants/constants";
import { useNavigate } from "react-router-dom";
import { routerPaths } from "../../constants/Paths";
import {
  formatCurrency,
  reverseFormatCurrency,
} from "../../utils/currency-formater";
import { WalletListRequest } from "../../services/Endpoints/wallet/WalletListEndpoint";

interface IChargeFormProps {
  onClose: () => void;
  walletId: number;
}

export default function ChargeForm({
  onClose,
  walletId,
}: Readonly<IChargeFormProps>) {
  const [waiting, setWaiting] = useState(false);

  const { setNotification } = useNotificationContext();
  const protectedInstance = useProtectedAxiosInstance();
  const { lang } = useLangContext();
  const navigate = useNavigate();
  const infos = compInfos[lang];

  const loginSchema = object({
    amount: string().required("مقدار واریزی ضروری است"),
    description: string().required("توضیحات ضروری است."),
  });

  const formik = useFormik({
    initialValues: {
      amount: "",
      description: "",
    },
    validationSchema: loginSchema,
    onSubmit: async (values) => {
      setWaiting(true);
      const walletChargeRequest = new WalletListRequest(protectedInstance);

      try {
        const { amount, description } = values;
        const resp = await walletChargeRequest.increase(walletId, {
          amount: +amount,
          description,
        });

        setWaiting(false);
        onClose();
      } catch (error: any) {
        errorResolver({ error, setNotification });
        setWaiting(false);
      }
    },
    enableReinitialize: true,
  });

  return (
    <Stack
      maxWidth="100%"
      width={{ xs: "95%", sm: "97%" }}
      gap="20.31px"
      mx="10px"
      component="form"
      onSubmit={formik.handleSubmit}
    >
      <MuiTextField
        isCurrency
        width="100%"
        name="amount"
        type="text"
        inputMode="numeric"
        placeholder={infos.inputs[0].placeholder}
        label={infos.inputs[0].label}
        value={formik.values.amount}
        handleChange={formik.handleChange}
        formatter={formatCurrency}
        reverseFormatter={reverseFormatCurrency}
        error={
          formik.touched.amount &&
          Boolean(formik.errors.amount) &&
          formik.errors.amount
        }
      />
      <MuiTextField
        multiline
        width="100%"
        name="description"
        type="text"
        placeholder={"لطفا دلیل افزایش اعتبار را وارد کنید"}
        label={"توضیحات"}
        value={formik.values.description}
        handleChange={formik.handleChange}
        error={
          formik.touched.description &&
          Boolean(formik.errors.description) &&
          formik.errors.description
        }
      />

      <LoadingButton variant="confirm" type="submit" loading={waiting}>
        {infos.buttonText}
      </LoadingButton>
    </Stack>
  );
}
//
